import React from "react";
import ESPServiceRequestGrid from "../../components/EServicePartnerServiceRequests/ESPServiceRequestGrid";
import ESPNavbar from "./ESPNavbar";
import { useState } from "react";
import api from "../../utils/api";
import { useEffect } from "react";
import { useLayoutEffect } from "react";
import { toast } from "react-toastify";
import find from "lodash/find";
import Spinner from "../../common/Spinner/Spinner";
import { getESPUser } from "../../utils/localStorage";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import { Button } from "../../common/Button/Button";
import {DOWNLOAD_API_URL}  from "../../utils/constants";

export default function UploadStatusProgressionSheetContainer(props)
{
    const [isLoading, setIsLoading] = useState(false);
    const ref = React.useRef();
    const history = useHistory();
    const [UploadStatusProgressionFile,setUploadStatusProgressionFile] = useState();
    const[activePage,setActivePage]=useState(""); 

    useEffect(() => {
        if (!getESPUser()) 
        {
			history.push("/service_partner/login");
		}
        else
        {
            const user = getESPUser();
            if (user&&user.external_partner_details&&user.external_partner_details.sServicePartnerOrg&&user.external_partner_details.sServicePartnerOrg.includes("Vakilsearch"))
            {
                setActivePage("UploadFileView");
            }
            else
            {
                setActivePage("No_Access");
            } 
        }
	},[]);

    const onUploadReport = () => {
		if (!UploadStatusProgressionFile) 
        {
            toast("Please select file.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
        let extension =UploadStatusProgressionFile.name.substring(UploadStatusProgressionFile.name.lastIndexOf('.')+1, UploadStatusProgressionFile.name.length) ||"";
        if(extension!='xlsx')
        {
            ref.current.value = "";
            setUploadStatusProgressionFile(null);
            toast("Please select xlsx file.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
        
        var formData = new FormData();
		formData.append("sp_service_data_upload",UploadStatusProgressionFile,UploadStatusProgressionFile.name);        
		setIsLoading(true);
		const data = api.UploadStatusProgressionSheet(formData)
			.then(({ data }) => {
                let sv=data;
                setIsLoading(false);
                ref.current.value = "";
                setUploadStatusProgressionFile(null);
                if(data&&data.message)
                {
                    if(data.message=='File uploaded and processed successfully')
                    {
                        toast(data.message, {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                    }
                    else
                    {
                        toast(data.message, {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }                    
                }
                else
                {
                    toast("File uploaded successful", {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    });
                }
			})
			.catch((error) => {
                setIsLoading(false);
                if(error&&error.response&&error.response.data&&error.response.data.message)
                {
                    toast(error.response.data.message, {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
                else{
                    toast("Internal server error", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
			});
	};

    const onFileSelected = (e) => {
		console.log("files", e.target.files);
		setUploadStatusProgressionFile(e.target.files[0]);
	};

    return(
        <>        
        {
            activePage==="UploadFileView"?
            (
                <div className={`${isLoading && "set-opacity"}`}>
                    {isLoading && <Spinner className="center-screen" />}
                    <div className="row"style={{marginTop:"10px"}}>
                        <div className="col-12 admin-upload-report">                            
                            <input className="form-control-custom" ref={ref} type="file"
                                accept=".xlsx"
                                onChange={onFileSelected}></input>                            
                            <Button onClick={onUploadReport}>Upload</Button> 
                            <a href={`${DOWNLOAD_API_URL}/static_live/templates/Excel%20sheet%20format.xlsx`} download="Excel_sheet_format.xlsx"> Download Sample File </a>
                        </div>
                    </div>
                </div>
            )
            :
            activePage==="No_Access"?
            (
                <div className={`row row-container`}>
                        <div className="col-12 row-margin-10px" style={{textAlign:"center"}}>                                
                        <label>
                            <b>You are not allowed to access this page, Please contact admin for more details.</b>
                        </label>         
                    </div>
                </div>
            )
            :
            (
                ""
            )}
        </>
    );

}